import { writable } from "svelte/store";

export const nanoID = writable(null);
export const billboardNode = writable(null);
export const adData = writable(null);

export const galleryData = writable(null);
export const galleryUrlData = writable("");

export const clickStoryData = writable(null);
export const clickStoryUrlData = writable("");
